module.exports = __webpack_public_path__ + "static/media/address-b-red-icon.e18b0158.svg";